module.exports = __webpack_public_path__ + "static/media/mobiles.21c49f92.png";